export const TEXTFIELD_TYPEAHEAD_ITEM_CLICK = "click";
export const TEXTFIELD_TYPEAHEAD_ITEM_SELECT = "select";
